import { Content } from '@tiptap/core'

import { EditorText } from '../../EditorText'
import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'

export type ReplyCommentProps = BaseNotificationItemProps & {
  userName: string
  message: string
  targetEntityId: string
  type: 'reply-comment'
}

export function ReplyComment({ userName, message, targetEntityId, ...props }: ReplyCommentProps) {
  return (
    <NotificationItem
      {...props}
      title={`${userName} replied to your comment`}
      subTitle={targetEntityId}
      descriptionAddon={
        <div className='flex text-left text-sm text-gray-500'>
          <p className='flex items-baseline'>
            <b className='min-w-fit'>{userName}</b>
            <p className='mr-1 ml-1'>wrote:</p>
            <EditorText initialData={JSON.parse(message) as Content} editable={false} truncateText hasQuote />
          </p>
        </div>
      }
    />
  )
}
